import { isConflicErrorWithFields, isDOIError, isPhoneConflict, isResubmitPriceAliveError } from '@wkda/funnel-modules';
import { isAxiosError } from '@wkda/funnel-utils';
import isObject from 'lodash-es/isObject';
import { createContext, useCallback, useContext, useMemo, useState } from 'react';
import { usePageData } from '../usePageData';
import { jsx as _jsx } from "react/jsx-runtime";
const initialState = {
  initialized: false,
  hasError: false,
  data: {},
  status: -1,
  statusText: '',
  setErrors: () => {}
};
export const ErrorContext = /*#__PURE__*/createContext({
  ...initialState
});
export function ErrorsProvider(_ref) {
  let {
    children
  } = _ref;
  const {
    initialError = {}
  } = usePageData();
  const [errors, _setErrors] = useState(() => {
    return {
      ...initialState,
      initialized: true,
      ...buildErrorObject(initialError)
    };
  });
  const setErrors = useCallback(function setErrors(error) {
    //TODO: Refactor errors implementation
    if (isPhoneConflict(error)) {
      return undefined;
    }
    _setErrors(prevState => {
      return {
        ...prevState,
        ...parseError(error),
        initialized: true
      };
    });
  }, []);
  const value = useMemo(() => {
    return {
      ...errors,
      setErrors
    };
  }, [errors, setErrors]);
  return /*#__PURE__*/_jsx(ErrorContext.Provider, {
    value: value,
    children: children
  });
}
export function useResponseErrors() {
  const ctx = useContext(ErrorContext);
  if (!ctx) {
    throw new Error('useResponseErrors must be used within a ErrorsProvider');
  }
  const {
    status,
    data,
    initialized,
    setErrors,
    hasError
  } = ctx;
  let body = {
    type: 'NOT_INITIALIZED',
    hasError,
    setErrors,
    statusCode: status
  };
  if (initialized && !hasError) {
    return body;
  }
  const errorBody = {
    result: data,
    statusCode: status
  };

  //A special kind of 409 error response
  if (isDOIError(errorBody)) {
    body = {
      ...body,
      type: 'DOI_ERROR'
    };
  } else if (isResubmitPriceAliveError(errorBody)) {
    body = {
      ...body,
      type: 'RESUBMIT_PRICE_ALIVE_ERROR'
    };
    // all 409 errors with a body with globalErrors and fieldErrors
  } else if (isConflicErrorWithFields(errorBody)) {
    const {
      fieldErrors = [],
      globalErrors = []
    } = data;
    const parsedFieldErrors = transformFieldErrors(fieldErrors);
    body = {
      ...body,
      globalErrors,
      fieldErrors: parsedFieldErrors,
      type: 'CONFLICT_ERROR'
    };
  } else {
    body = {
      ...body,
      type: 'OTHER_ERROR'
    };
  }
  return body;
}
export function parseError(error) {
  if (isAxiosError(error)) {
    const {
      response
    } = error;
    const {
      status,
      statusText,
      data
    } = response;
    return buildErrorObject({
      status,
      statusText,
      data
    });
  }
  return {
    hasError: error.hasError ?? true,
    data: error.data ?? {},
    statusText: error.statusText ?? '',
    status: error.status ?? -1
  };
}
export function buildErrorObject(_ref2) {
  let {
    status,
    statusText,
    data
  } = _ref2;
  const hasError = status >= 400 && status < 600;
  const payload = isObject(data) ? data : {};
  return {
    hasError,
    status,
    statusText,
    data: payload
  };
}
function transformFieldErrors(fieldErrors) {
  let transformed = {};
  if (!Array.isArray(fieldErrors)) {
    return transformed;
  }
  for (const error of fieldErrors) {
    transformed[error.field] = {
      message: error.message,
      value: error.rejectedValue
    };
  }
  return transformed;
}